var render = function render(){var _vm=this,_c=_vm._self._c;return _c('inertia-head',{attrs:{"title":_vm.title
            ? `${_vm.title} - King Sound Reinforcement`
            : 'King Sound Reinforcement'}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }